import { useState, useEffect } from 'react'
import api from '../../services/api'
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, BarChart, Bar, CartesianGrid, Legend } from 'recharts'

export default function Reportes() {
  const [stats, setStats] = useState(null)
  const [agentes, setAgentes] = useState([])
  const [porDia, setPorDia] = useState([])
  const [desde] = useState(new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10))
  const [hasta] = useState(new Date().toISOString().slice(0, 10))

  useEffect(() => {
    api.get('/dashboard', { params: { desde, hasta } }).then(r => setStats(r.data))
    api.get('/agentes', { params: { desde, hasta } }).then(r => setAgentes(r.data))
    api.get('/mensajes-por-dia', { params: { desde, hasta } }).then(r => setPorDia(r.data))
  }, [desde, hasta])

  if (!stats) return <div className="loading-fullscreen"><div className="spinner" /></div>

  return (
    <div className="page">
      <h1 className="text-2xl font-bold" style={{ marginBottom: 18 }}>📈 Reportes</h1>
      <p className="text-muted" style={{ marginBottom: 20 }}>Últimos 30 días</p>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-card-label">Contactos</div>
          <div className="stat-card-value">{stats.contactos.total}</div>
          <div className="stat-card-trend text-success">+{stats.contactos.nuevos} nuevos</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Chats abiertos</div>
          <div className="stat-card-value">{stats.chats.abiertos}</div>
          <div className="stat-card-trend text-muted">{stats.chats.cerrados} cerrados</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Mensajes</div>
          <div className="stat-card-value">{stats.mensajes.total}</div>
          <div className="stat-card-trend text-muted">{stats.mensajes.entrantes} in · {stats.mensajes.salientes} out</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Negocios ganados</div>
          <div className="stat-card-value">{stats.negocios.ganados}</div>
          <div className="stat-card-trend text-success">${parseFloat(stats.negocios.valorGanado).toFixed(2)}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-label">Tiempo respuesta</div>
          <div className="stat-card-value">{Math.round(stats.tiempoRespuestaPromedioSeg / 60)} min</div>
          <div className="stat-card-trend text-muted">Promedio primera respuesta</div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 className="card-title">📊 Mensajes por día</h3>
        <div className="chart-wrap" style={{ height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={porDia}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
              <XAxis dataKey="fecha" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="entrantes" stroke="#3b82f6" strokeWidth={2} name="Entrantes" />
              <Line type="monotone" dataKey="salientes" stroke="#10b981" strokeWidth={2} name="Salientes" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="card">
        <h3 className="card-title">🧑‍💼 Desempeño por agente</h3>
        <div className="chart-wrap" style={{ height: 280 }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={agentes}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
              <XAxis dataKey="nombre" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="mensajesEnviados" fill="#128C7E" name="Mensajes enviados" />
              <Bar dataKey="chatsAtendidos" fill="#25D366" name="Chats atendidos" />
              <Bar dataKey="negociosGanados" fill="#075E54" name="Negocios ganados" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  )
}
